import User, { hasRole, Role } from '@/models/User'
import Waste from '@/models/Waste'

export default class WastePolicy {
	viewAny(_user: User): boolean {
		return true
	}

	view(user: User, waste: Waste) {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === waste.entry.catalog.company.id
			case Role.AUDITOR:
				return waste.entry.catalog.company.auditors?.some(auditor => auditor.id === user.auditor?.id)
			default:
				return false
		}
	}

	create(user: User) {
		return hasRole(user, Role.USER)
	}

	update(user: User, waste: Waste) {
		return hasRole(user, Role.USER) && user.company?.id === waste.entry.catalog.company.id
	}

	restore(user: User, waste: Waste) {
		return hasRole(user, Role.USER) && user.company?.id === waste.entry.catalog.company.id
	}

	delete(user: User, waste: Waste) {
		return hasRole(user, Role.USER) && user.company?.id === waste.entry.catalog.company.id
	}

	forceDelete(_user: User, _waste: Waste) {
		return false
	}
}
